import React, { lazy, Suspense } from "react";

/**
 * Replacement for react-loadable using React.lazy and Suspense.
 * Accepts the same config format.
 */
export default function MyLoadable({ loader, loading: LoadingComponent }) {
    const LazyComponent = lazy(loader);

    return (props) => (
        <Suspense fallback={<LoadingComponent />}>
            <LazyComponent {...props} />
        </Suspense>
    );
}